"use strict";
angular.module("planCommandCustomFunctionManageRouterModule", ['planCommandMonitorCustomFunctionManageModule', 'planCommandMonitorCustomFuncComplieModule'])
    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state("front.planningresource.commandMonitor.customfunctionmanage", {
                url: '/customfunctionmanage',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/customFuncManage/customFunctionManage_tpl.html',
                        controller: 'planCommandMonitorCustomFunctionManageCtrl',
                    }
                }
            })
            .state("front.planningresource.commandMonitor.customfunctionmanage.customfunccompile", {
                url: '/customfunccompile?id',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/customFuncManage/customFuncCompile/customFuncCompile_tpl.html',
                        controller: 'planCommandMonitorCustomFuncComplieCtrl',
                    }
                }
            });
    }]);